<template>
  <PageContent>
    <template slot="heading-title">Outdoor mobile coverage map</template>
    <div class="map" slot="content">
      <div class="menu-container">
        <Menu></Menu>
      </div>
      <div class="map-container">
        <CustomMap></CustomMap>
      </div>
      <MessageModal/>
    </div>
  </PageContent>
</template>

<script>
import Menu from '@/components/custom/Menu';
import CustomMap from '@/components/custom/CustomMap';
import PageContent from '@/components/abstract/PageContent';
import { MAP } from '@/enum/screens.enum';
import { mapActions } from 'vuex';
import MessageModal from '@/components/custom/MessageModal';

export default {
  data () {
    return {}
  },
  components: { MessageModal, Menu, CustomMap, PageContent },
  methods: {
    ...mapActions('map', ['screenVisited'])
  },
  mounted() {
    this.screenVisited({ screen: MAP });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import 'nib'

.map
  column()
  min-height 100vh

.menu-container
  column()
  height 100%

.map-container
  column()
  flex-grow 1
  height 100vh

</style>



// WEBPACK FOOTER //
// src/components/pages/MapPage.vue